import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AudioComponent, TimePipe } from './player.component'
@NgModule({
    imports: [BrowserModule],
    declarations: [AudioComponent, TimePipe],
    exports: [AudioComponent, TimePipe]
})
export class PlayerModule {}